module.exports = __webpack_public_path__ + "static/img/24.3bc2e27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/生活照/24.jpg
// module id = D0RL
// module chunks = 0